import { Stack, Text, vars } from '@etg/wings';
import { Overlay } from '@eti/components';
import { TransferType } from '@eti/schema-types';
import { css } from '@eti/styles';
import { DYNAMIC_ICON } from '../../common/utils/dynamic-icons/icons';
import { useDynamicIcon } from '../../common/utils/dynamic-icons/useDynamicIcon';
import ProductDrawerCard from '../../common/components/ProductDrawerCard';
import { AirportDirection, convertToHoursAndMinutes } from './utils';
import TransferBoundAvailability from './TransferBoundAvailability';
import TicketDetailsSection from './TicketDetailsSection';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const withIcon = iconContent => css`
  color: ${vars.colors.links.default};
  position: relative;

  &::after {
    bottom: 4px;
    content: ${iconContent};
    display: inline-block;
    height: 16px;
    margin-inline-start: 4px;
    position: relative;
    vertical-align: bottom;
    width: 16px;
  }
`;
const renderBounds = (operator, available, fromTitle, toTitle) => {
  const boundDirections = operator.airportDirection === AirportDirection.Both ? [AirportDirection.From, AirportDirection.To] : [operator.airportDirection];
  return /*#__PURE__*/_jsx(Stack, {
    children: boundDirections.map((direction, index) => {
      const title = direction === AirportDirection.From ? fromTitle : toTitle;
      return /*#__PURE__*/_jsx(TransferBoundAvailability, {
        available: available,
        boundsData: operator.transferBoundData,
        direction: direction,
        title: title
      }, index);
    })
  });
};
const AirportTransferDrawer = _ref => {
  let {
    translation,
    operator,
    handleClose
  } = _ref;
  const [icon] = useDynamicIcon(vars.colors.links.default, DYNAMIC_ICON.linkIcon);
  if (!operator || operator.transferBoundData.length === 0 || operator.airportDirection === AirportDirection.None) {
    return null;
  }
  const {
    transferCarrier,
    transferTime,
    transferBoundData,
    transferType
  } = operator;
  const {
    availableTickets,
    transferBetween,
    termsAndConditions,
    available,
    ticketDetails,
    andTranslation,
    operatingHours,
    conditions,
    pleaseNote,
    operatingHoursContent,
    conditionsContent,
    pleaseNoteContent
  } = translation.drawer;
  const {
    fromAirport,
    toAirport,
    hour,
    hours,
    minute,
    minutes,
    transferTime: transferTranslation,
    bus,
    train
  } = translation.card;
  const transferTypeText = transferType === TransferType.Bus ? bus : train;
  const arrival = transferBoundData[AirportDirection.From].arrivalStation;
  const departure = transferBoundData[AirportDirection.From].departureStation;
  const detailDirection = `${transferTypeText} ${transferBetween} ${departure} ${andTranslation} ${arrival}`;
  const termsAndConditionsUrl = transferBoundData[AirportDirection.From].termsAndConditions;
  const transferTimeText = convertToHoursAndMinutes(transferTime !== null && transferTime !== void 0 ? transferTime : 0, hour, hours, minute, minutes, transferTranslation);
  return /*#__PURE__*/_jsxs(Overlay.Drawer, {
    dataTestId: "airport-transfer-drawer",
    handleClose: handleClose,
    id: "airportTransfer-info-drawer",
    isOpen: Boolean(operator),
    children: [/*#__PURE__*/_jsx(Overlay.Header, {
      onClose: handleClose,
      title: transferCarrier
    }), /*#__PURE__*/_jsxs(Overlay.Content, {
      children: [/*#__PURE__*/_jsx(ProductDrawerCard, {
        cardTitle: availableTickets,
        children: renderBounds(operator, available, fromAirport, toAirport)
      }), /*#__PURE__*/_jsx(ProductDrawerCard, {
        cardTitle: ticketDetails,
        children: /*#__PURE__*/_jsxs(Stack, {
          children: [/*#__PURE__*/_jsx(TicketDetailsSection, {
            content: [detailDirection, transferTimeText]
          }), /*#__PURE__*/_jsx(TicketDetailsSection, {
            content: operatingHoursContent,
            title: operatingHours
          }), /*#__PURE__*/_jsx(TicketDetailsSection, {
            content: conditionsContent,
            title: conditions
          }), /*#__PURE__*/_jsx(TicketDetailsSection, {
            content: pleaseNoteContent,
            title: pleaseNote
          }), termsAndConditionsUrl && /*#__PURE__*/_jsx(Text, {
            as: "a",
            className: withIcon(icon),
            "data-testid": "airport-transfer-drawer-link",
            href: termsAndConditionsUrl,
            rel: "noreferrer",
            target: "_blank",
            children: termsAndConditions
          })]
        })
      })]
    })]
  });
};
export default AirportTransferDrawer;
//# sourceMappingURL=AiportTransferDrawer.js.map